import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="31bs09botatln">
      <CountdownBar data-id="element-1" data-mp="31ctf7r8y808n" />
      <main data-id="element-2" data-mp="2wk06yte9u9rt">
        <Hero data-id="element-3" data-mp="2wjgp1comflds" />
        <StatsBar data-id="element-4" data-mp="2wiyy8vkq9zd9" />
        <Difference data-id="element-5" data-mp="2wiffjcn976y6" />
        <Recognize data-id="element-6" data-mp="2whxbhtucnofp" />
        <WhatsInside data-id="element-7" data-mp="28ufoebm15ej2" />
        <Bonuses data-id="element-8" data-mp="28tmfb3zlmcxr" />
        <Offer data-id="element-9" data-mp="28t4mkhc5agul" />
        <Guarantee data-id="element-10" data-mp="28sur4e8bzhhi" />
        <Faq data-id="element-11" data-mp="28s2y9b64bxux" />
        <FinalCta data-id="element-12" data-mp="23vcikoy874a1" />
      </main>
      <Footer data-id="element-13" data-mp="23u9t8lgjx9w8" />
    </div>;
}